import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, retry, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import * as FileSaver from 'file-saver';
import { EmpresaService } from '../../Empresa/Empresa.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ReporteListaPreciosService {
  empresaId = String(environment.empresaId);
  private destroy$ = new Subject<void>();

  tiposPrecio = {
    'PU': 'publico',
    'PN': 'normal',
    'ES': 'especial',
    'VO': 'volumen',
    'MA': 'mayoreo',
    'SV': 'superVolumen'
  }

  constructor(private http: HttpClient, private empresaService: EmpresaService) {
    this.empresaService.empresaId$
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        this.empresaId = id;
      });
  }

  public setExportExcel(clienteId: string, datos: any) {

    const dataQuery = {
      option: 'getListaPrecios',
      empresaId: this.empresaId,
      ...datos
    }
    let f = new Date();
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post<any>(
        environment.apiUrl +
        'reportes/reporte-lista-precios/reporte-lista-precios.php',
        dataQuery,
        { headers, responseType: 'blob' as 'json' }
      )
      .pipe(
        map((data1) => {
          var blob = new Blob([data1], { type: 'application/vnd.ms.excel' });

          const nombreEmpresa = this.empresaService.getEmpresaNombre(Number(this.empresaId)) + "_";
          const tipoReporte = (datos.tipoReporte == "C" ? 'cliente_' + clienteId : 'categorias');
          const fecha = String(f.getDate()).padStart(2, '0') + '_' + String(f.getMonth() + 1).padStart(2, '0') + '_' + f.getFullYear();
          const fileName = 'Lista_precios_' + nombreEmpresa + tipoReporte + '_' + fecha + '.xlsx';

          const file = new File([blob], fileName, {
            type: 'application/vnd.ms.excel',
          });
          FileSaver.saveAs(file);
        })
      )
      .toPromise();
  };

  getClientes = () => {
    const data = {
      option: "getVentasAbcClientes",
      empresaId: this.empresaId,
    }
    return this.http.post<any>(environment.apiUrl + '/reportes/reporte-abc/get_reporte_abc.php', data).pipe(retry(3),
      catchError(this.handleError), map(response => {
        return response;
      }));


  }
  private handleError = (error: HttpErrorResponse | any) => {

    Swal.fire({
      type: 'error',
      title: 'Error',
      text:
        'Lo sentimos, Ocurrio un error de comunicación, Favor de contactarse con el administrador del sitio incidencias@integradora.net' + error.message
    });
    return throwError(error);
  }


}




